import { DeliveryStatus, MembershipStatusTranslation } from 'commons'

export const MAX_FILE_SIZE_MB = 2
export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024
export const columnMap: { [key: string]: string } = {
  'Correo Electronico': 'email',
  Nombres: 'names',
  'Apellido Paterno': 'paternalLastName',
  'Apellido Materno': 'maternalLastName',
  Telefono: 'phone',
  Producto: 'productName',
  RFC: 'taxId',
  'Estado del Registro': 'status',
  ID: 'ID',
  Pago: 'paymentFrequency',
}
export const STORAGE_KEY = 'bulkLoadTableData'
export const DELIVERY_STATUS_INFO = {
  [DeliveryStatus.ENVIANDO]: 'El email está en proceso de llegar al destinatario',
  [DeliveryStatus.RECIBIDO]: 'El email ha sido entregado en la bandeja del destinatario',
  [DeliveryStatus.ABIERTO]: 'El email fue abierto por el destinatario',
  [DeliveryStatus.RECHAZADO]:
    'No se pudo entregar el email, la bandeja del destinatario podría estar llena',
  [DeliveryStatus.INEXISTENTE]:
    'Dirección de email no existe, es necesario modificarla para enviar email nuevamente',
  [DeliveryStatus.SUPRIMIDO]: 'Enviado a lista de supresión de AWS',
  [DeliveryStatus.SPAM]:
    'El destinatario nos ha clasificado como SPAM, por lo que se ha bloqueado el envío de correos adicionales',
  [DeliveryStatus.BOUNCE]:
    'No se pudo entregar el email, la bandeja del destinatario podría estar llena',
} as const

export const MEMBERSHIP_STATUS_INFO = {
  [MembershipStatusTranslation.VIGENTE]:
    'La cobertura está activa y goza de los beneficios del Seguro de Salud Inteligente',
  [MembershipStatusTranslation.SUSPENDIDA]:
    'La cobertura está suspendida, el colaborador no cuenta con la protección del Seguro',
  [MembershipStatusTranslation.CANCELADA]:
    'La cobertura está cancelada, el colaborador fue dado de baja permanentemente',
  [MembershipStatusTranslation.COMPLETADA]:
    'Proceso completado. La cobertura entrará pronto en aprobación.',
  [MembershipStatusTranslation.APROBACION]:
    'La cobertura está en periodo de aprobación (24 a 72 hrs.) Agradecemos tu paciencia.',
} as const
export const ZERO_PLACEHOLDER = '0.00'
